var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',_vm._b({staticClass:"sidebar",attrs:{"app":"","color":"grey700","right":"","touchless":""},on:{"input":_vm.setSidebarOpen}},'v-navigation-drawer',_vm.sidebarAttributes,false),[_c('Inventory')],1)}
var staticRenderFns = []

export { render, staticRenderFns }